import { clone } from '@jack-henry/frontend-utils/functions';
import { ElectronicDocumentProductModelDto } from '@treasury/api/bo';
import { FeatureApiType } from '../../types/product-feature.enum';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: ElectronicDocumentProductModelDto = {
    monthlyFee: 0,
    documentType: 2,
    id: 0,
    productUniqueId: '',
    type: FeatureApiType.ElectronicDocuments,
    isConfigurable: false,
};
export class ElectronicDocumentsProductFeature extends CompanyProductFeature<ElectronicDocumentProductModelDto> {
    constructor(dto: ElectronicDocumentProductModelDto = clone(defaultDto)) {
        super(dto);
    }

    public get esiId() {
        return this.dto.esiId ?? '';
    }

    public set esiId(value: string) {
        this.dto.esiId = value;
    }

    public get esiEmail() {
        return this.dto.esiEmail ?? '';
    }

    public set esiEmail(value: string) {
        this.dto.esiEmail = value;
    }
}
